import { Fragment } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Marquee } from "../components/Marquee";
import { TraceryDivider } from "../components/Ornament";
import { Hero } from "../components/home/Hero";
import { SectionBlock } from "../components/home/SectionBlock";
import { About } from "../components/home/About";
import { ContactForm } from "../components/home/ContactForm";
import { useSite } from "../context/SiteContext";

export default function Home() {
  const { site } = useSite();

  if (!site) {
    return (
      <div className="min-h-screen bg-[#070709] flex items-center justify-center" data-testid="home-loading">
        <p className="font-mono text-xs tracking-[0.4em] uppercase text-[#78716c] flicker">Unsealing the vault…</p>
      </div>
    );
  }

  return (
    <div className="relative" data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee text={site.settings?.marquee} />
      <div id="sections">
        {(site.sections || []).map((s, i) => (
          <Fragment key={s.id}>
            {i > 0 && <TraceryDivider cat={i} />}
            <SectionBlock section={s} index={i} />
          </Fragment>
        ))}
      </div>
      <TraceryDivider cat={0} />
      <About />
      <ContactForm />
      <Footer />
    </div>
  );
}
